import { z } from 'zod';

export const trustedDeviceDtoSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  label: z.string().max(120).nullable(),
  userAgent: z.string().nullable(),
  lastSeenIp: z.string().max(64).nullable(),
  lastSeenAt: z.string().datetime(),
  createdAt: z.string().datetime(),
});

export const trustedDeviceListSchema = z.array(trustedDeviceDtoSchema);

export type TrustedDeviceDto = z.infer<typeof trustedDeviceDtoSchema>;
